import { render, staticRenderFns } from "./stage1.vue?vue&type=template&id=80c90d8c&scoped=true&"
import script from "./stage1.vue?vue&type=script&lang=js&"
export * from "./stage1.vue?vue&type=script&lang=js&"
import style0 from "./stage1.vue?vue&type=style&index=0&id=80c90d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c90d8c",
  null
  
)

export default component.exports